import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import { string, number, func } from 'prop-types';

import './Incremental.scss';
Incremental.propTypes = {
  setIncrement: func,
  increment: number,
  className: string
};

export default function Incremental(props) {
  const { setIncrement, increment, className } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(increment);
  const inputRef = useRef(null);

  function decreaseIncrement() {
    inputRef?.current?.focus();
    if (isEditing) {
      setInputValue((inputValue ? inputValue : 0) - 1);
    } else {
      setIncrement(Math.round((increment - 1) * 1e2) / 1e2);
    }
  }

  function increaseIncrement() {
    inputRef?.current?.focus();
    if (isEditing) {
      setInputValue((inputValue ? inputValue : 0) + 1);
    } else {
      setIncrement(Math.round((increment + 1) * 1e2) / 1e2);
    }
  }

  function startEditing() {
    setInputValue(increment);
    setIsEditing(true);
  }

  function endEditing(e) {
    if (!e.relatedTarget?.className.includes('incremental__round-btn')) {
      if (inputValue) {
        setIncrement(Math.round(inputValue * 1e2) / 1e2);
      } else if (inputValue === null) {
        setIncrement(0);
      }
      setIsEditing(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === 'Tab') endEditing(e);
  }

  function handleOnChange(e) {
    let targetValue = parseFloat(e.target.value);
    if (!isNaN(targetValue)) {
      setInputValue(targetValue);
    } else if (e.target.value === '') {
      setInputValue(0);
    }
  }

  return (
    <div className={classnames('incremental__controls-container', className)}>
      <button
        className={classnames('incremental__round-btn minus incremental__subtract-btn', { editing: isEditing })}
        onClick={decreaseIncrement}
      />
      {!isEditing ? (
        <div onClick={startEditing} className="incremental__edit-container">
          {increment}%
          <i className="icon-pencil incremental__edit-icon" />
        </div>
      ) : (
        <input
          ref={inputRef}
          autoFocus
          value={inputValue}
          className={classnames('incremental__text-box')}
          onKeyDown={handleKeyDown}
          onBlur={endEditing}
          onChange={handleOnChange}
          step={0.01}
          min={-100}
          max={100}
          type="number"
        />
      )}
      <button
        className={classnames('incremental__round-btn plus incremental__add-btn', { editing: isEditing })}
        onClick={increaseIncrement}
      />
    </div>
  );
}
